(function( $ ){ 
    var videoCarousel = null;
    $.expr[':'].external = function (obj) {
      return !obj.href.match(/^mailto:/) && (obj.hostname != location.hostname);
    };
   $('a:external').attr('target', '_blank');
    $('.video-thumbnail-overlay').on('click', function () {
      const $overlay = $(this);
      const $wrapper = $overlay.closest('.pp-cpr.video-embed-wrapper');
      const $iframe = $wrapper.find('iframe');


      const newSrc = $iframe.attr('src');
      const autoplaySrc = newSrc.includes('?') ? newSrc + '&autoplay=1' : newSrc + '?autoplay=1';

      // 🔇 Stop ALL other videos
      if($('.pp-cpr.video-embed-wrapper.playing').length > 0){
        var ___url = $('.pp-cpr.video-embed-wrapper.playing').data('video-url');
        $('.pp-cpr.video-embed-wrapper.playing iframe').attr('src', ''); 
        $('.pp-cpr.video-embed-wrapper.playing iframe').attr('src', ___url); 
      }

      $iframe.attr('src', autoplaySrc);
      // Hide the clicked overlay
      $('.video-thumbnail-overlay').fadeIn(); // reset all overlays
      $overlay.fadeOut(300);
      $('.pp-cpr.video-embed-wrapper').removeClass('playing');
      $wrapper.addClass('playing');
      
    });

    if( get_url_param('sf-frm')){
      console.log('We here');
      // {
      //   // $('.frm-thank-you').show();
      //   // $('.frm-thank-you + form, #frm-intro').hide();
      // }
    }


    $('body.product-details .comparison-table-block .table-reveal-btn').on('click', function(e){
      $(this).toggleClass('on off');
    });
    $('body.product-details .comparison-table-block .cpr-tbl-collapse').on('click', function(e){
      e.preventDefault();
      $('.table-reveal-btn', $(this).parents('.comparison-table-block')).toggleClass('on off');
    });

    // var clickedSummary = null;
    // $('summary[data-url]').on('click', function (e) {
    //   var $summary = $(this);
    //   var $details = $summary.parent('details');
    //   var url = $summary.data('url');

    //   // Prevent default summary toggle behavior
    //   e.preventDefault();

    //   // If this is the second click (i.e. already open), navigate
    //   if ($details.attr('open') !== undefined && clickedSummary && clickedSummary.is($summary)) {
    //     window.location.href = url;
    //     return;
    //   }

    //   // Otherwise open the dropdown
    //   // Close others if needed
    //   $('details.has-submenu').not($details).removeAttr('open');
    //   $details.attr('open', true);
    //   clickedSummary = $summary;
    // });

    // $(document).on('click', function (e) {
    //   if (!$(e.target).closest('summary').length) {
    //     clickedSummary = null;
    //   }
    // });
    
    $(window).on('load', function() {
      if($('.cpr-image-rotator').length > 0){
        $('.cpr-image-rotator').each(function(){
          $(this).slick({
              infinite: true,
              prevArrow: '',
              nextArrow: '',
              autoplaySpeed: 4000,
              speed: 500,
              fade: true,
              cssEase: 'linear',
              dots: false,
              autoplay: true,
              rows: 0,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: false,
          });
        });
      }

      if($('.retailer-carousel .retailer').length > 0){
          $('.retailer-carousel').slick({
            infinite: true,
            prevArrow: '<button class="next"><span class="sr-only">Next</span></button>',
            nextArrow: '<button class="prev"><span class="sr-only">Previous</span></button>',
            dots: true,
            autoplay: false,
            mobileFirst: true,
            rows: 0,
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                },
            ],
          });
      }
      $('.slick-dots').each(function () {
        if ($(this).children('li').length === 1) {
          $(this).hide();
        }
      });

      if($('#product-main-carousel').length > 0){
        $('#product-main-carousel').on('init', function(event, slick){
          $(this).parents('.carousel-wrapper').addClass('slider-initialised');
        });
        $('#product-main-carousel').slick({
          infinite: true,
          prevArrow: '',
          nextArrow: '',
          dots: false,
          autoplay: true,
          autoplaySpeed: 3000,
          //rows: 0,
          fade: true,
          cssEase: 'linear',
          slidesToShow: 1,
          adaptiveHeight: true,
          //appendArrows: $('#carousel-nav-wrapper'),
        });

        $('#product-main-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          if($('.video-wrapper video').length > 0){
            currVideo.pause();
          }
        });
      }
      
      if($(".pp-video-carousel .pp-carousel-wrapper").length > 0){
          videoCarousel = $('.pp-video-carousel .pp-carousel-wrapper').slick({
              infinite: false,
              prevArrow: '',
              nextArrow: '',
              dots: false,
              rows: 0,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
            });
        }
      });

     if($(".pp-video-carousel .pp-carousel-wrapper").length > 0){
        $(".pp-video-carousel .pp-carousel-wrapper").on('beforeChange', function(event, slick, currentSlide, nextSlide){
            if($('.pp-cpr.video-embed-wrapper.playing').length > 0){
              var ___url = $('.pp-cpr.video-embed-wrapper.playing').data('video-url');
              $('.pp-cpr.video-embed-wrapper.playing iframe').attr('src', ''); 
              $('.pp-cpr.video-embed-wrapper.playing iframe').attr('src', ___url); 
              $('.pp-cpr.video-embed-wrapper').removeClass('playing');
              $('.video-thumbnail-overlay').fadeIn();
            }
        });
        $('.pp-video-carousel-nav a').on('click', function(e){
            e.preventDefault();
             $('.pp-video-carousel-nav a.on').removeClass('on')
            $(this).addClass('on');
            $('.pp-video-carousel .pp-carousel-wrapper').slick('slickGoTo', $(this).data('slide-index'));
        })
     }

  function get_url_param(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
  };
})( jQuery );